export default "__VITE_ASSET__DuZmjsM8__"